import { SearchFilterTag } from '@/components';
import {
  CandidateOfInspectionByExternalExpertLabelModifier,
  type ProjectSearchFormType,
} from '@/features/search/_models/projects-search';
import { isPS } from '@/utils';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const IsCandidateOfInspectionByExternalExpertTag: FC = () => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });
  const skipAdministrativeReformTeamEvaluation = useWatch({
    control,
    name: 'skipAdministrativeReformTeamEvaluation',
  });

  const isCandidateOfInspectionByExternalExpert = useWatch({
    control,
    name: 'isCandidateOfInspectionByExternalExpert',
  });

  if (
    sheetType !== 'RS' ||
    skipAdministrativeReformTeamEvaluation === 'true' ||
    !isCandidateOfInspectionByExternalExpert ||
    isPS()
  ) {
    return null;
  }

  return (
    <SearchFilterTag
      closable={true}
      label={`${t('candidate-of-inspection-by-external-expert')}: ${
        CandidateOfInspectionByExternalExpertLabelModifier[
          isCandidateOfInspectionByExternalExpert
        ]
      }`}
      onClose={() => {
        setValue('isCandidateOfInspectionByExternalExpert', null);
      }}
    />
  );
};
